import { render, staticRenderFns } from "./ManageSavedSearches.vue?vue&type=template&id=247cf951&"
import script from "./ManageSavedSearches.vue?vue&type=script&lang=js&"
export * from "./ManageSavedSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports